import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import {
  CORPORATE_TYPE,
  CRITERIA_GROUP,
  DEFAULT_CURRENCY,
  INDUSTRY_TYPE,
  OTHER_DATA,
} from '../../common/constant'
import { handleValidateCriteria } from './helper'
import { getTotalResult } from './thunk'

const initialState = {
  currentGroupTab: CRITERIA_GROUP.BASIC_INFORMATION,
  currentIndustryTab: INDUSTRY_TYPE.VSIC,
  currentFinancialTab: CORPORATE_TYPE.CORPORATE,

  criteria: {
    [CRITERIA_GROUP.BASIC_INFORMATION]: {},
    [CRITERIA_GROUP.INDUSTRY]: {
      industryType: undefined,
      listIdCheckedTree: [],
      ids: [],
    },
    [CRITERIA_GROUP.FINANCIALS]: {},
    [OTHER_DATA]: {
      currency: DEFAULT_CURRENCY,
    },
  },

  applyingCriteria: null,

  totalResult: 0,
  loadingTotalResult: false,
}

const name = 'tool/screening/selectCriteria'

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeGroupTab: (state, action) => {
      state.currentGroupTab = action.payload
    },
    changeIndustryTab: (state, action) => {
      state.currentIndustryTab = action.payload
    },
    changeFinancialTab: (state, action) => {
      state.currentFinancialTab = action.payload
    },
    applyCriteria: (state, action) => {
      const criteria = action.payload
      state.applyingCriteria = criteria
      if (criteria && criteria.parameters) {
        state.criteria = criteria.parameters
      }
    },
    changeCriteria: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.criteria, path, data)
    },
    resetCriteria: (state, action) => {
      state.criteria = initialState.criteria
    },
    changeTotalResult: (state, action) => {
      state.totalResult = action.payload
    },
    validateCriteria: (state, action) => {
      const { callback } = action.payload
      const isValid = handleValidateCriteria(state.criteria)
      callback(isValid)
    },
  },
  extraReducers: (builder) => {
    // Total Result
    builder.addCase(getTotalResult.pending, (state) => {
      state.loadingTotalResult = true
    })
    builder.addCase(getTotalResult.fulfilled, (state, action) => {
      state.totalResult = action.payload
      state.loadingTotalResult = false
    })
    builder.addCase(getTotalResult.rejected, (state, action) => {
      state.loadingTotalResult = action.payload.loading
    })
  },
})

export const selectCurrentGroupTab = (state) =>
  state[slice.name].currentGroupTab
export const selectCurrentIndustryTab = (state) =>
  state[slice.name].currentIndustryTab
export const selectCurrentFinancialTab = (state) =>
  state[slice.name].currentFinancialTab

export const selectCriteria =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].criteria,
    )
    return callback ? callback(data) : data
  }
export const selectSelectedIndicatorCount = (state) => {
  const data = state[slice.name].criteria

  const basicInformationCount = Object.values(
    data[CRITERIA_GROUP.BASIC_INFORMATION],
  ).filter(Boolean).length
  const industryCount =
    data[CRITERIA_GROUP.INDUSTRY].ids.length ||
    data[CRITERIA_GROUP.INDUSTRY].listIdCheckedTree.length
      ? 1
      : 0
  const financialCount = Object.values(data[CRITERIA_GROUP.FINANCIALS]).filter(
    Boolean,
  ).length

  return basicInformationCount + industryCount + financialCount
}

export const selectTotalResult = (state) => state[slice.name].totalResult
export const selectLoadingTotalResult = (state) =>
  state[slice.name].loadingTotalResult

export const selectApplyingCriteria = (callback) => (state) => {
  const data = state[slice.name].applyingCriteria
  return callback ? callback(data) : data
}

export const {
  resetStore,
  changeGroupTab,
  changeIndustryTab,
  changeFinancialTab,
  applyCriteria,
  changeCriteria,
  resetCriteria,
  changeTotalResult,
  validateCriteria,
} = slice.actions

register(slice.name, slice.reducer)
